function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { getElements } from "./selector.js"; // local variables

var nativeEvents = ["click", "focus", "blur"];
/*
  ------------------------------------------------------------------------------
  Adds event listener to an element. Using namespaces is available.

  @param {String|Element|NodeList|Array} elements Selector, single or multiple elements
  @param {String} eventNames Space separated event names with optional namespaces
  @param {Function} callback The function to execute when the event occurs
  @param {Object} options [optional] Optional options
*/

var addEventListener = function addEventListener(elements, eventNames, callback) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  elements = getElements(elements);
  elements.forEach(function (element) {
    // eslint-disable-next-line no-prototype-builtins
    if (!element.hasOwnProperty("registeredEvents")) {
      element.registeredEvents = [];
    }

    eventNames.split(" ").forEach(function (eventName) {
      var _eventName$split = eventName.split("."),
          _eventName$split2 = _slicedToArray(_eventName$split, 1),
          eventNameType = _eventName$split2[0];

      var theCallback = function theCallback() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return callback.apply(void 0, args.concat([element]));
      };

      element.registeredEvents.push({
        eventName: eventName,
        callback: theCallback,
        options: options
      });
      element.addEventListener(eventNameType, theCallback, options);
    });
  });
};
/*
  ------------------------------------------------------------------------------
  Delegates event listener to an element. Using namespaces is available.

  @param {String} elements Selector
  @param {String} eventNames Space separated event names with optional namespaces
  @param {Function} callback The function to execute when the event occurs
*/


var delegateEventListener = function delegateEventListener(selector, eventNames, callback) {
  addEventListener(document, eventNames, function (e) {
    var element = e.target.closest(selector);

    if (element) {
      callback(e, element);
    }
  });
};
/*
  ------------------------------------------------------------------------------
  Removes event listener from an element. Using namespaces is available.

  @param {String|Element|NodeList|Array} elements Selector, single or multiple elements
  @param {String} eventNames Space separated event names with optional namespaces
  @param {Function} callback The function to execute when the event occurs
  @param {Object} options [optional] Optional options
*/


var removeEventListener = function removeEventListener(elements) {
  var eventName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  elements = getElements(elements);
  elements.forEach(function (element) {
    // eslint-disable-next-line no-prototype-builtins
    if (!element.hasOwnProperty("registeredEvents")) {
      return;
    } // remove all event listeners


    if (!eventName && !callback && !options) {
      element.registeredEvents.forEach(function (regEvent) {
        element.removeEventListener(regEvent.eventName.split(".")[0], regEvent.callback, regEvent.options);
      });
      element.registeredEvents = [];
      return;
    } // remove specific and/or namespaced event listeners


    var _eventName$split3 = eventName.split("."),
        _eventName$split4 = _slicedToArray(_eventName$split3, 2),
        eventNameType = _eventName$split4[0],
        eventNameSpace = _eventName$split4[1];

    element.registeredEvents.forEach(function (regEvent) {
      var _regEvent$eventName$s = regEvent.eventName.split("."),
          _regEvent$eventName$s2 = _slicedToArray(_regEvent$eventName$s, 2),
          regEventNameType = _regEvent$eventName$s2[0],
          regEventNameSpace = _regEvent$eventName$s2[1];

      var regEventNameMatch = regEvent.eventName === eventName || !eventNameSpace && eventNameType && eventNameType === regEventNameType || !eventNameType && eventNameSpace && eventNameSpace === regEventNameSpace;
      var doRemove = false; // only 'eventName' provided

      if (eventName && !callback && !options) {
        if (regEventNameMatch) {
          doRemove = true;
        }
      } // only 'callback' provided
      else if (!eventName && callback && !options) {
        if (callback === regEvent.callback) {
          doRemove = true;
        }
      } // only 'options' provided
      else if (!eventName && !callback && options) {
        if (options === regEvent.options) {
          doRemove = true;
        }
      } // 'eventName' and 'callback' provided
      else if (eventName && callback && !options) {
        if (regEventNameMatch && callback === regEvent.callback) {
          doRemove = true;
        }
      } // 'callback' and 'options' provided
      else if (!eventName && callback && options) {
        if (callback === regEvent.callback && options === regEvent.options) {
          doRemove = true;
        }
      } // everything's provided
      else {
        if (regEventNameMatch && callback === regEvent.callback && options === regEvent.options) {
          doRemove = true;
        }
      }

      if (doRemove) {
        element.removeEventListener(regEventNameType, regEvent.callback, regEvent.options);
        element.registeredEvents = element.registeredEvents.filter(function (e) {
          return e !== regEvent;
        });
      }
    });
  });
};
/*
  ------------------------------------------------------------------------------
  Triggers event on an element. Using namespaces is available.

  @param {String|Element|NodeList|Array} elements Selector, single or multiple elements
  @param {String} eventNames Space separated event names with optional namespaces
  @param {Mixed} data The data to pass. Not available for `nativeEvents` events
*/


var triggerEvent = function triggerEvent(elements, eventNames) {
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  elements = getElements(elements);
  elements.forEach(function (element) {
    eventNames.split(" ").forEach(function (eventName) {
      var _eventName$split5 = eventName.split("."),
          _eventName$split6 = _slicedToArray(_eventName$split5, 2),
          eventNameType = _eventName$split6[0],
          eventNameSpace = _eventName$split6[1];

      var eventTriggered = false; // trigger registered event
      // eslint-disable-next-line no-prototype-builtins

      if (element.hasOwnProperty("registeredEvents")) {
        var eventsTriggered = [];
        element.registeredEvents.forEach(function (registeredEvent) {
          var _registeredEvent$even = registeredEvent.eventName.split("."),
              _registeredEvent$even2 = _slicedToArray(_registeredEvent$even, 2),
              regEventNameType = _registeredEvent$even2[0],
              regEventNameSpace = _registeredEvent$even2[1]; // do not trigger the exact events more than once


          if (eventsTriggered.includes(registeredEvent.eventName)) {
            return;
          }

          if ( // type (and namespace) trigger (e.g. 'click.goBaby')
          eventName === registeredEvent.eventName || // type only trigger (e.g. 'click')
          !eventNameSpace && eventNameType === regEventNameType || // namespace only trigger (e.g. '.goBaby')
          !eventNameType && eventNameSpace === regEventNameSpace) {
            // trigger native event
            if (nativeEvents.includes(regEventNameType)) {
              element[regEventNameType]();
            } // trigger custom event
            else {
              var event = new CustomEvent(registeredEvent.eventName, {
                detail: data
              });
              element.dispatchEvent(event);
            }

            eventsTriggered.push(registeredEvent.eventName);
            eventTriggered = true;
          }
        });
      } // trigger non-registered event


      if (!eventTriggered && eventNameType) {
        // trigger native event
        if (nativeEvents.includes(eventNameType)) {
          element[eventNameType]();
        } // trigger custom event
        else {
          var event = new CustomEvent(eventNameType, {
            detail: data
          });
          element.dispatchEvent(event);
        }
      }
    });
  });
};
/*
  ------------------------------------------------------------------------------
*/


export { addEventListener, delegateEventListener, removeEventListener, triggerEvent };